module.exports = __webpack_public_path__ + "media/images/mobile/city_img/c_head-facbd2e43b0c6177689c239cd3941a39.jpg";